import * as React from 'react';
import { UitkText } from 'uitk-react-text';

interface HygieneMessagingProps {
  message: string;
}

export const HygieneMessaging = ({ message }: HygieneMessagingProps) => <UitkText size={200}>{message}</UitkText>;
